import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { AuthNoticeService } from '../../../core/auth';
import { HttpClient } from '@angular/common/http';
import { MessagesService } from '../../../core/e-commerce/_services/messages.service';

@Component({
    selector: 'kt-dialog-product',
    templateUrl: './dialog-message.component.html',
    styleUrls: ['./dialog-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogMessageComponent implements OnInit {

    detailForm: FormGroup;
    error: boolean = false;
    isLoadingResults = false;
    messageTypes = [
        {
            value: 'Comunicandonos',
            name: 'Comunicandonos',
        },
        {
            value: 'FeDeErratas',
            name: 'FeDeErratas',
        },
    ];
    isActive = [
        {
            value: true,
            name: 'Activo',
        },
        {
            value: false,
            name: 'Inactivo',
        },
    ];

    constructor(
        private messagesService: MessagesService,
        private _snackBar: MatSnackBar,
        private http: HttpClient,
        private dialog: MatDialog,
        private cdr: ChangeDetectorRef,
        public dialogRef: MatDialogRef<DialogMessageComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private fb: FormBuilder,
        private authNoticeService: AuthNoticeService,
    ) {
    }

    ngOnInit() {
        this.authNoticeService.setNotice(null);
        this.initForms();
    }

    initForms() {
        let model;
        if (this.data) {
            model = this.data;
        } else {
            model = {};
        }

        this.detailForm = this.fb.group({
            // id: [model.id, Validators.required],
            messageType: [model.messageType, Validators.required],
            isActive: [model.isActive, Validators.required],
            description: [model.description, Validators.required],
            reachId: [model.reachId, Validators.required],
        });
    }

    saveOrderEvent() {
        const controls = this.detailForm.controls;
        if (this.detailForm.invalid) {
            Object.keys(controls).forEach(controlName => {
                    controls[controlName].markAsTouched();
                }
            );
            return;
        }

        if (this.data == null) {
            this.messagesService.createMessage(this.detailForm.value).subscribe(resp => {
                    this.dialogRef.close(true);
                    this.cdr.detectChanges();
                },
                error => {
                    let message = 'Ha ocurrido un error';
                    this._snackBar.open(message, 'OK', {
                        duration: 3000,
                    });
                });
        } else {
            this.messagesService.updateMessage(this.detailForm.value, this.data.id).subscribe(() => {
                    this.dialogRef.close(true);
                },
                error => {
                    let message = 'Ha ocurrido un error';
                    this._snackBar.open(message, 'OK', {
                        duration: 3000,
                    });
                });
        }
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    isControlHasError(controlName: string, validationType: string): boolean {
        const control = this.detailForm.controls[controlName];
        if (!control) {
            return false;
        }

        return control.hasError(validationType) && (control.dirty || control.touched);
    }
}
